const {Component} = require("react");
const PropTypes = require("prop-types");
const env = require("app/services/env");
const Pikaday = require("pikaday");
const moment = require("moment");
const LazyImg = require("app/components/mixins/LazyImg");
const router = require("app/services/router");
const hammer = require("app/util/hammer");
const element = require("app/util/element");

class PikadayField extends Component {

	static get propTypes() {
		return {
			name: PropTypes.string,
			min: PropTypes.string,
			max: PropTypes.string,
			value: PropTypes.string,
			format: PropTypes.string,
			placeholder: PropTypes.string,
			onChange: PropTypes.func,
			disableDayFn: PropTypes.func
		};
	}

	static get defaultProps() {
		return {
			format: "DD.MM.YYYY",
			placeholder: translate("Vælg dato...")
		};
	}

	componentDidMount() {
		let options = {};

		options.field = this.inputElement;
		options.format = this.props.format
		options.firstDay = 1;
		options.keyboardInput = false;

		options.onSelect = (date) => {
			if (typeof this.props.onChange === "function") {
				this.props.onChange(date);
			}
		};

		if (this.props.min) {
			options.minDate = moment(this.props.min, "YYYY-MM-DD").toDate();
		}

		if (this.props.max) {
			options.maxDate = moment(this.props.max, "YYYY-MM-DD").toDate();
		}

		if (this.props.value) {
			options.defaultDate = moment(this.props.value, "YYYY-MM-DD").toDate();
			options.setDefaultDate = true;
		}

		if (typeof this.props.disableDayFn === "function") {
			options.disableDayFn = this.props.disableDayFn;
		}

		if (env.has("pikaday.language")) {
			options.i18n = env.get("pikaday.language");
		}

		this.picker = new Pikaday(options);

		if (this.props.value === null) {
			this.picker.setDate(null);
		}

		// Bind on touch out event
		const bodyWrapper = document.body.querySelector(".body-wrapper");

		if (bodyWrapper) {
			hammer(bodyWrapper).on("tap", e => {
				if (!this.isVisible()) {
					return;
				}

				if ((e.target === this.bodyElement) || (element(e.target).parent(".pikaday-picker") === this.bodyElement)) {
					return;
				}

				if ((e.target === this.picker.el) || (element(e.target).parent(".pika-single") === this.picker.el)) {
					return;
				}

				this.hide();

				if (this.inputElement && (typeof this.inputElement.blur === "function")) {
					this.inputElement.blur();
				}
			});
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.min) {
			this.picker.setMinDate(moment(nextProps.min, "YYYY-MM-DD").toDate());
		}

		if (nextProps.max) {
			this.picker.setMaxDate(moment(nextProps.max, "YYYY-MM-DD").toDate());
		}
	}

	get value() {
		const value = this.picker.getDate();
		return value ? moment(value).format("YYYY-MM-DD") : null;
	}

	show() {
		if (this.picker) {
			this.picker.show();
		}
	}

	hide() {
		if (this.picker) {
			this.picker.hide();
		}
	}

	isVisible() {
		if (this.picker) {
			return this.picker.isVisible();
		}
	}

	render() {
		return (
			<div ref={el => this.bodyElement = el} className="date-picker pikaday-picker">
				<LazyImg src={router.url("img/icons/calendar.png")} name="Date picker" critical='true'/>
				<input name={this.props.name} className="select" ref={el => this.inputElement = el} type="text" placeholder={this.props.placeholder} readOnly={true}/>
			</div>
		);
	}

}

module.exports = PikadayField;
